<template>
<div id="aozora">
    <header>
      <HeaderWhite/>
    </header>
    <main class="aozora-overview">
        <span class="aozora-overview-title">会社概要</span>
        <ul>
            <li class="aozora-list-contents">
                <span class="aozora-subheading">会社名</span>
                <span class="aozora-contents">株式会社青空</span>
            </li>
            <li class="aozora-list-contents">
                <span class="aozora-subheading">設立</span>
                <span class="aozora-contents">2021年7月1日</span>
            </li>
            <li class="aozora-list-contents">
                <span class="aozora-subheading">代表者名</span>
                <span class="aozora-contents">山田晋平</span>
            </li>
            <li class="aozora-list-contents">
                <span class="aozora-subheading">所在地</span>
                <span class="aozora-contents aozora-address">〒440-0888 豊橋市駅前大通3丁目118番地先 大豊ビルA-2棟 冷や水</span>
            </li>
            <li class="aozora-list-contents">
                <span class="aozora-subheading">事業内容</span>
                <ul class="aozora-contents">
                    <li class="aozora-content-li">
                        <span class="aozora-content-index">1.</span>
                        <span class="business-content-detail">舞台演出映像及び芸術領域の映像作品の製作、オペレーション並びにディレクション</span>
                    </li>
                    <li class="aozora-content-li">
                        <span class="aozora-content-index">2.</span>
                        <span class="business-content-detail">芸術作品の映像デジタルアーカイブの製作</span>
                    </li>
                    <li class="aozora-content-li">
                        <span class="aozora-content-index">3.</span>
                        <span class="business-content-detail">芸術教育目的の鑑賞会の企画、制作、運営</span>
                    </li>
                    <li class="aozora-content-li">
                        <span class="aozora-content-index">4.</span>
                        <span class="business-content-detail">各種イベント、コンサートの企画、運営</span>
                    </li>
                    <li class="aozora-content-li">
                        <span class="aozora-content-index">5.</span>
                        <span class="business-content-detail">自治体と連携した芸術文化事業の企画、運営</span>
                    </li>
                    <li class="aozora-content-li">
                        <span class="aozora-content-index">6.</span>
                        <span class="business-content-detail">グラフィックデザイン等の制作</span>
                    </li>
                    <li class="aozora-content-li">
                        <span class="aozora-content-index">7.</span>
                        <span class="business-content-detail">講師派遣</span>
                    </li>
                    <li class="aozora-content-li">
                        <span class="aozora-content-index">8.</span>
                        <span class="business-content-detail">上記各号に附帯関連する一切の事業</span>
                    </li>
                </ul>
            </li>
        </ul>
    </main>
    <footer class="footer">
        <Footer/>
    </footer>
</div>
</template>

<script>
import HeaderWhite from '@/components/common/HeaderWhite.vue'
import Footer from '../components/common/Footer'
export default {
    name: 'aozora',
    components: {
        HeaderWhite,
        Footer
        },
}
</script>

<style lang="scss" scope>
.aozora-overview {
    margin: 0 auto;
    width: 90%;
    margin-top: 45px;
}
.aozora-overview-title {
    display: inline-block;
    line-height: normal;
    border-bottom: solid 1px #000000;
    font-size: 16px;
    margin-bottom: 26px;
}
.aozora-subheading {
    display: inline-block;
    width: 30%;
    max-width: 100px;
    font-size: 14px;
    font-weight: bold;
}
.aozora-address {
    display: block;
    margin-left: 20px;
} 
.aozora-contents {
    font-size: 15px;
}
.aozora-list-contents {
    // display: flex;
    margin-bottom: 10px;
}
.aozora-content-li {
    display: flex;
    margin-top:10px;
}
.aozora-content-index {
    display: block;
    margin-right: 10px;
    margin-left: 20px;
}

// PC
@media screen and (min-width: 768px) {
    .aozora-overview-title {
        font-size: 16px;
        margin-bottom: 26px;
        }
    .aozora-overview {
        margin: 0 auto;
        width: 60%;
        margin-top: 100px;
        min-width: 800px;
    }
    .aozora-overview-title {
        font-size: 16px;
        margin-bottom: 26px;
    }
    .aozora-subheading {
        width: 10%;
        font-size: 14px;
        font-weight: bold;
    }
    .aozora-contents {
        font-size: 16px;
    }
    .aozora-list-contents {
        display: flex;
        margin-bottom: 10px;
    }
    .aozora-address {
        margin-left: 0px;
    } 
    .aozora-content-li:nth-child(1) {
        margin-top:0px;
    }
    .aozora-content-index {
    margin-left: 0px;
}
.footer {
    position: absolute;
    bottom: 0;
}

}
</style>